import ComingSoon from "components/ComingSoon";
import React from "react";

export const BundleData = () => {
  return <ComingSoon />;
};
